/* eslint-disable jsx-a11y/media-has-caption */
import * as Yup from "yup";
import React, { useEffect, useRef, useState } from "react";
import { FaPlay } from "react-icons/fa";
import { FiMail } from "react-icons/fi";
import { MdClose, MdLocalPhone } from "react-icons/md";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import { useHistory } from "react-router-dom";

import CheckBoxField from "components/layout/form/checkBoxField";
import Navbar from "components/MI/Navbar";
import OutlinedButton from "components/layout/form/outlinedButton";
import TextField from "components/layout/form/textField";
import UserMenu from "components/layout/userMenuNew";
import api from "services/api";
import { cellPhoneNumberRegex } from "utils/regex";

import {
  ButtonContainer,
  ButtonIcon,
  ButtonLink,
  Container,
  Content,
  ContentButtons,
  ContentField,
  ContentImg,
  ContentInfo,
  ContentToken,
  Field,
  Form,
  Img,
  Label,
  ModalContainer,
  ModalHeader,
  ModalStyle,
  SubtitleInfo,
  Text,
  TextError,
  TextLabel,
  TextTimer,
  TitleInfo,
} from "./styles";

const formatTimer = (timer: number): string => {
  // @ts-ignore
  let minutes = parseInt(timer / 60, 10);
  // @ts-ignore
  let seconds = parseInt(timer % 60, 10);
  // @ts-ignore
  minutes = minutes < 10 ? `0${minutes}` : minutes;
  // @ts-ignore
  seconds = seconds < 10 ? `0${seconds}` : seconds;
  return `${minutes}:${seconds}`;
};

const UltragazEnergia = (): JSX.Element => {
  const [showModal, setShowModal] = useState(false);
  const [data, setData] = useState({});
  const [isNotValidate, setIsNotValidate] = useState([]);
  const [selectTypeValidation, setSelectTypeValidation] = useState();
  const [timer, setTimer] = useState(60);
  const [startTimer, setStartTimer] = useState(false);
  const [validationType, setValidationType] = useState("");
  const [validationValue, setValidationValue] = useState("");
  const [step, setStep] = useState("validationOption");
  const [showModalValidation, setShowModalValidation] = useState(false);
  const [loading, setLoading] = useState(false);

  const history = useHistory();
  const intervalRef = useRef();
  let newTimer = 60;

  const validationSchema = (): void =>
    Yup.object().shape({
      isAcceptedTerm: Yup.boolean("Campo obrigatório"),
    }) as any;

  const validationSchemaEmail = (): void =>
    Yup.object().shape({
      email: Yup.string()
        .email("E-mail inválido")
        .required("É necessário informar um e-mail"),
    }) as any;

  const validationSchemaToken = (): void =>
    Yup.object().shape({
      token: Yup.string().required("É necessário informar um token"),
    }) as any;

  const validationSchemaPhone = (): void =>
    Yup.object().shape({
      phoneNumber: Yup.string()
        .required("É necessário informar um número de celular")
        .test("Telefone", "Número de telefone inválido", (value) => {
          if (value) {
            value = value.replace(/[^\d]/g, "");
            return !!value.match(cellPhoneNumberRegex);
          }
          return null;
        }),
    }) as any;

  const formik = useFormik({
    initialValues: {
      isAcceptedTerm: false,
      isAcceptedContact: false,
    },
    validationSchema,
    onSubmit: async (values, helper) => {
      if (!values.isAcceptedTerm) {
        helper.setFieldError("isAcceptedTerm", "Este campo é obrigatório.");
      }

      if (values.isAcceptedTerm) {
        if (isNotValidate?.length > 0) {
          setSelectTypeValidation(isNotValidate[0]);
          setShowModalValidation(true);
        } else {
          const body = {
            ...data,
            ...values,
          };
          const accessToken = localStorage.getItem(
            "@UltragazEmpresarial:accessToken"
          );
          const headers = {
            access_token: accessToken,
          };

          try {
            const result = await api.post(
              "industrial/customer/v1/customers/lead",
              body,
              {
                headers,
              }
            );

            const userId = localStorage.getItem("@UltragazEmpresarial:userId");

            const bodyAcceptedTerms = {
              type: "ENERGY",
              termsAccepted: true,
              additionalData: {
                sendSmsAccepted: values.isAcceptedContact,
              },
            };
            const responseAcceptedTerms = await api.post(
              `industrial/customer/v1/users/${userId}/accept-terms`,
              bodyAcceptedTerms,
              {
                headers,
              }
            );

            if (
              result.status === 201 &&
              (responseAcceptedTerms.status === 201 ||
                responseAcceptedTerms.status === 202)
            ) {
              history.push("/ultragaz-energia/sucesso");
            }
          } catch (error) {
            toast.error(
              error?.message ?? "Ocorreu um erro interno na aplicação"
            );
          }
        }
      }
    },
  });

  const formikEmail = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: validationSchemaEmail,
    onSubmit: async (values) => {
      await handleSubmitEmail(values);
    },
  });

  const formikPhone = useFormik({
    initialValues: {
      phoneNumber: "",
    },
    validationSchema: validationSchemaPhone,
    onSubmit: async (values) => {
      await handleSubmitPhone(values);
    },
  });

  const formikToken = useFormik({
    initialValues: {
      token: "",
    },
    validationSchema: validationSchemaToken,
    onSubmit: async (values) => {
      await handleSubmitToken(values);
    },
  });

  const decreaseNum = (): void => {
    if (newTimer === 0) {
      setStartTimer(false);
      clearInterval(intervalRef.current);
      return;
    }
    setTimer((prev) => {
      newTimer -= 1;
      return prev - 1;
    });
  };

  useEffect(() => {
    if (startTimer) {
      // @ts-ignore
      intervalRef.current = setInterval(decreaseNum, 1000);
    }

    return () => clearInterval(intervalRef.current);
  }, [startTimer]);

  const sendToken = async (type, value): Promise<void> => {
    const userId = localStorage.getItem("@UltragazEmpresarial:userId");
    const document = localStorage.getItem("@UltragazEmpresarial:document");
    const customerSiteId = localStorage.getItem(
      "@UltragazEmpresarial:customerSiteId"
    );
    const headers = {
      access_token: localStorage.getItem("@UltragazEmpresarial:accessToken"),
    };

    const bodyContact = {
      contactType: type,
      contact: value,
      document,
      siteId: customerSiteId,
    };

    try {
      const { headers: headersContact } = await api.post(
        `industrial/customer/v1/users/${userId}/contacts`,
        bodyContact,
        { headers }
      );

      const contactId = headersContact?.location?.split("contacts/")[1];

      const bodyToken = {
        contactId,
        tokenType: "REGISTER",
        contact: value,
        contactType: type,
        url: null,
      };

      await api.post(
        `industrial/customer/v1/users/${userId}/tokens`,
        bodyToken,
        {
          headers,
        }
      );

      toast.warn(`Enviamos um código de verificação para ${value}`);
    } catch (error) {
      toast.error(error?.message ?? "Ocorreu um erro interno na aplicação");
    }
  };

  const validationToken = async (token): Promise<void> => {
    const userId = localStorage.getItem("@UltragazEmpresarial:userId");
    const headers = {
      access_token: localStorage.getItem("@UltragazEmpresarial:accessToken"),
    };

    const bodyToken = {
      token,
    };

    let success;
    try {
      await api.post(
        `industrial/customer/v1/users/${userId}/validations`,
        bodyToken,
        {
          headers,
        }
      );

      toast.success("Contato validado com sucesso.");

      if (validationType === "EMAIL") {
        setData((prev) => ({
          ...prev,
          email: validationValue,
        }));
      }

      if (validationType === "PHONE") {
        const phoneDdd = validationValue.slice(0, 2);
        const phoneNumber = validationValue.slice(2, 99);

        setData((prev) => ({
          ...prev,
          phoneDdd,
          phoneNumber,
        }));
      }

      if (isNotValidate.length > 1) {
        setSelectTypeValidation(isNotValidate[1]);
        setIsNotValidate([isNotValidate[1]]);
        resetStep();
      } else {
        setShowModalValidation(false);
        setIsNotValidate([]);
        formik.handleSubmit();
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message ?? "Ocorreu um erro interno na aplicação"
      );
      success = false;
    }

    return success;
  };

  const handleSubmitToken = async (data): Promise<void> => {
    setLoading(true);
    await validationToken(data.token);
    setLoading(false);
  };

  const handleSubmitEmail = async (data): Promise<void> => {
    setLoading(true);
    await sendToken("EMAIL", data.email);
    setStep("validationToken");
    setValidationType("EMAIL");
    setValidationValue(data.email);
    setStartTimer(true);
    setLoading(false);
  };

  const handleSubmitPhone = async (data): Promise<void> => {
    setLoading(true);
    const value = data.phoneNumber.replace(/[^\d]/g, "");
    await sendToken("PHONE", value);
    setStep("validationToken");
    setValidationType("PHONE");
    setValidationValue(value);
    setStartTimer(true);
    setLoading(false);
  };

  const resetStep = (): void => {
    setStep("validationOption");
    setStartTimer(false);
    formikToken.resetForm();
    setTimer(60);
  };

  const resendToken = async (): Promise<void> => {
    setLoading(true);
    setTimer(60);
    setStartTimer(true);
    await sendToken(validationType, validationValue);
    setLoading(false);
  };

  const onHide = (): void => {
    setShowModalValidation(false);
  };

  useEffect(() => {
    (async () => {
      await getContacts();
    })();
  }, []);

  const getContacts = async (): Promise<void> => {
    // const userId = localStorage.getItem("@UltragazEmpresarial:userId");
    const headers = {
      access_token: localStorage.getItem("@UltragazEmpresarial:accessToken"),
    };
    const response = await api.get(
      `industrial/customer/v1/customers/me/contacts?is-contact-validated=true`,
      {
        headers,
      }
    );
    const { data } = response;
    if (data?.length) {
      const isEmailValidated = data.find(
        (contact) =>
          contact.contactType === "EMAIL" && contact.isValidated === true
      );
      const isPhoneValidated = data.find(
        (contact) =>
          contact.contactType === "PHONE" && contact.isValidated === true
      );

      const isNotValidateData = [];

      if (isPhoneValidated) {
        const phoneDdd = isPhoneValidated.contact.slice(0, 2);
        const phoneNumber = isPhoneValidated.contact.slice(2, 99);

        setData((prev) => ({
          ...prev,
          phoneDdd,
          phoneNumber,
          name: isPhoneValidated.name,
        }));
      } else {
        isNotValidateData.push("PHONE");
      }

      if (isEmailValidated) {
        setData((prev) => ({
          ...prev,
          email: isEmailValidated.contact,
          // @ts-ignore
          name: prev.name ? prev.name : isEmailValidated.name,
        }));
      } else {
        isNotValidateData.push("EMAIL");
      }

      const document = localStorage.getItem("@UltragazEmpresarial:document");
      const stateCode = localStorage.getItem("@UltragazEmpresarial:stateCode");

      const responseME = await api.get(`industrial/customer/v1/customers/me`, {
        headers,
      });

      if (responseME.data) {
        const { birthDate, corporateName } = responseME.data;

        setData((prev) => ({
          ...prev,
          birthDate,
          // @ts-ignore
          name: prev.name ? prev.name : corporateName,
        }));
      }

      setData((prev) => ({
        ...prev,
        document,
        stateCode,
      }));

      setIsNotValidate(isNotValidateData);
    }
  };

  return (
    <Navbar selected="ultragaz-energia">
      <UserMenu />
      <Container>
        <Content>
          <ContentImg>
            <Img src="/static/banner_ultragaz-energia.png" />
            <ButtonIcon onClick={() => setShowModal(true)}>
              <FaPlay />
            </ButtonIcon>
          </ContentImg>
          <ContentInfo>
            <TitleInfo>
              Ganhe desconto na sua conta de luz todos os meses!
            </TitleInfo>
            <SubtitleInfo>
              Conheça a nova solução da Ultragaz que oferece desconto na conta
              de luz.
            </SubtitleInfo>
            <Form>
              <Label>
                <CheckBoxField
                  name="isAcceptedTerm"
                  id="isAcceptedTerm"
                  // @ts-ignore
                  value={formik.values.isAcceptedTerm}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                >
                  Concordo com os{" "}
                  <a href="https://energia.ultragaz.com.br/termos-de-uso/">
                    Termos de Uso
                  </a>
                  *
                </CheckBoxField>
                {formik.errors.isAcceptedTerm && (
                  <TextError>{formik.errors.isAcceptedTerm}</TextError>
                )}
              </Label>
              <Label>
                <CheckBoxField
                  name="isAcceptedContact"
                  id="isAcceptedContact"
                  // @ts-ignore
                  value={formik.values.isAcceptedContact}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                >
                  Aceito receber conteúdo da Ultragaz Energia sobre produtos
                  desponíveis, via meios de contato inseridos por mim
                  ativamente, tais como e-mail, celular e WhatsApp.
                </CheckBoxField>
                {formik.errors.isAcceptedContact && (
                  <TextError>{formik.errors.isAcceptedContact}</TextError>
                )}
              </Label>
              <ButtonContainer
                type="button"
                onClick={() => formik.handleSubmit()}
              >
                Quero desconto!
              </ButtonContainer>
            </Form>
            <Text>
              Cancele a qualquer hora, sem cobrança de multa. Não há motivos
              para não ter Ultragaz Energia.
            </Text>
            <ButtonLink
              target="_blank"
              href={process.env.REACT_APP_URL_ULTRAGAZENERGIA}
            >
              Saiba mais
            </ButtonLink>
          </ContentInfo>
        </Content>
      </Container>
      <ModalStyle
        show={showModal}
        onHide={() => setShowModal(false)}
        size="xl"
        animation={false}
        centered
      >
        <video controls autoPlay>
          <source src="/static/video_ultragaz-energia.mp4" type="video/mp4" />
        </video>
      </ModalStyle>
      <ModalStyle
        show={showModalValidation}
        onHide={onHide}
        centered
        backdrop="static"
        keyboard={false}
      >
        <ModalContainer>
          <ModalHeader>
            <div>
              <div>
                <h2>Valide seus contatos</h2>
                <span>
                  Com todos os contatos validados você aproveita tudo que o{" "}
                  <b>Portal Minha Ultragaz</b> pode oferecer.
                </span>
              </div>
              <MdClose size={24} onClick={onHide} />
            </div>
          </ModalHeader>

          {step === "validationOption" && (
            <div>
              {selectTypeValidation === "EMAIL" && (
                <form onSubmit={formikEmail.handleSubmit}>
                  <span>Um código será enviado no email informado</span>
                  <ContentField>
                    <Field>
                      <TextField
                        LeadingIcon={<FiMail size={24} />}
                        type="text"
                        name="email"
                        label="Email *"
                        onChange={formikEmail.handleChange}
                        onBlur={formikEmail.handleBlur}
                        value={formikEmail.values.email}
                        // @ts-ignore
                        errorCondition={
                          formikEmail.errors.email && formikEmail.touched.email
                        }
                        // @ts-ignore
                        errorMessage={formikEmail.errors.email}
                        disabled={loading}
                      />
                    </Field>
                    <OutlinedButton
                      type="submit"
                      disabled={
                        !formikEmail.values.email ||
                        !!formikEmail.errors.email ||
                        loading
                      }
                      loading={loading}
                    >
                      Validar email
                    </OutlinedButton>
                  </ContentField>
                </form>
              )}
              {selectTypeValidation === "PHONE" && (
                <form onSubmit={formikPhone.handleSubmit}>
                  <span>Um código será enviado no celular informado</span>
                  <ContentField>
                    <Field>
                      <TextField
                        LeadingIcon={<MdLocalPhone size={24} />}
                        name="phoneNumber"
                        mask="(99) 9 9999-9999"
                        label="Celular com DDD *"
                        onChange={formikPhone.handleChange}
                        onBlur={formikPhone.handleBlur}
                        value={formikPhone.values.phoneNumber}
                        // @ts-ignore
                        errorCondition={
                          formikPhone.errors.phoneNumber &&
                          formikPhone.touched.phoneNumber
                        }
                        // @ts-ignore
                        errorMessage={formikPhone.errors.phoneNumber}
                        disabled={loading}
                      />
                    </Field>
                    <OutlinedButton
                      type="submit"
                      disabled={
                        !formikPhone.values.phoneNumber ||
                        !!formikPhone.errors.phoneNumber ||
                        loading
                      }
                      loading={loading}
                    >
                      SMS
                    </OutlinedButton>
                  </ContentField>
                </form>
              )}
            </div>
          )}
          {step === "validationToken" && (
            <ContentToken>
              <TextLabel>
                {validationType === "EMAIL" &&
                  "O código foi enviado para o email informado"}
                {validationType === "PHONE" && "O código foi enviado por SMS"}
              </TextLabel>
              <form onSubmit={formikToken.handleSubmit}>
                <Field>
                  <TextField
                    name="token"
                    label="Inserir código *"
                    onChange={formikToken.handleChange}
                    onBlur={formikToken.handleBlur}
                    value={formikToken.values.token}
                    // @ts-ignore
                    errorCondition={
                      formikToken.errors.token && formikToken.touched.token
                    }
                    // @ts-ignore
                    errorMessage={formikToken.errors.token}
                    disabled={loading}
                  />
                </Field>
                <TextTimer>
                  Não recebi o código.{" "}
                  {timer > 0 ? (
                    `Aguarde ${formatTimer(timer)}`
                  ) : (
                    <a href="#" onClick={resendToken}>
                      Enviar novamente
                    </a>
                  )}
                </TextTimer>
                <ContentButtons id="content-buttons">
                  <OutlinedButton
                    disabled={
                      !formikToken.values.token ||
                      !!formikToken.errors.token ||
                      loading
                    }
                    type="submit"
                    loading={loading}
                  >
                    Validar código
                  </OutlinedButton>
                  {timer <= 0 && (
                    <OutlinedButton
                      onClick={resetStep}
                      disabled={loading}
                      loading={loading}
                    >
                      Alterar{" "}
                      {validationType === "EMAIL" ? "e-mail" : "celular"}
                    </OutlinedButton>
                  )}
                </ContentButtons>
              </form>
            </ContentToken>
          )}
        </ModalContainer>
      </ModalStyle>
    </Navbar>
  );
};

export default UltragazEnergia;
